import React, { useEffect, useRef, useState } from 'react';
import { apiUrl } from '../../config/api';
import './AnnouncementBar.scss';

/** Scrolling promotional strip above the header. Renders nothing when empty. */
const AnnouncementBar = () => {
  const [message, setMessage] = useState('');
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const controller = new AbortController();

    (async () => {
      try {
        const response = await fetch(apiUrl('/api/announcement'), {
          method: 'GET',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        if (isMounted.current && data.success && data.announcement) {
          setMessage(data.announcement);
        }
      } catch {
        // A missing announcement is not an error worth showing anyone.
      }
    })();

    return () => {
      isMounted.current = false;
      controller.abort();
    };
  }, []);

  if (!message) return null;

  return (
    <div className="ij-announce">
      <div className="ij-announce__track">
        {/* A single copy: it scrolls fully out of view before repeating. */}
        <p className="ij-announce__text">{message}</p>
      </div>
    </div>
  );
};

export default AnnouncementBar;
